<template>
  <div id="app">
    <HeaderComponent :socials="socials" :isOptionsContentLoaded="isOptionsContentLoaded" />

    <div id="page">
      <transition
        name="fade"
        mode="out-in"
        @beforeLeave="beforeLeave"
        @enter="enter"
        @afterEnter="afterEnter"
      >
        <router-view :key="$route.name + ($route.params.id || '')"/>
      </transition>

      <FooterComponent :footerAddress="footerAddress" :footerContent="footerContent" :socials="socials" :isOptionsContentLoaded="isOptionsContentLoaded" />
    </div>
  </div>
</template>

<script>
import HeaderComponent from './components/Layouts/Header'
import FooterComponent from './components/Layouts/Footer'
import axios from 'axios'
export default {
  name: 'App',
  components: {
    HeaderComponent,
    FooterComponent
  },
  data () {
    return {
      api_path: process.env.VUE_APP_API_PATH,
      prevHeight: 0,
      footerAddress: null,
      socials: [],
      footerContent: null,
      isOptionsContentLoaded: false
    }
  },
  mounted () {
    this.getOptions()
  },
  methods: {
    getOptions () {
      const vm = this
      const lang = this.$route.params.lang
      axios.get(`${this.api_path}wp-json/acf/v3/options/${lang}`)
        .then(res => {
          if (res.data) {
            vm.footerAddress = res.data.acf.footer_address
            vm.footerContent = res.data.acf.footer_content
            vm.socials = res.data.acf.social_network
            vm.isOptionsContentLoaded = true
          }
        })
    },
    beforeLeave (element) {
      this.prevHeight = getComputedStyle(element).height
    },
    enter (element) {
      const { height } = getComputedStyle(element)
      element.style.height = height
      setTimeout(() => {
        element.style.height = height
      })
    },
    afterEnter (element) {
      element.style.height = 'auto'
    }
  }
}
</script>

<style lang="sass" scoped>
.fade-enter-active,
.fade-leave-active
  transition-duration: 0.3s
  transition-property: height, opacity
  transition-timing-function: ease
  overflow: hidden
.fade-enter,
.fade-leave-active
  opacity: 0
</style>
